export default "__VITE_ASSET__HAhIwcpM__"